import './UploadFileModal.scss';

import {InboxOutlined} from '@ant-design/icons';
import {Divider, Form, Upload} from 'antd';
import React, {useState} from 'react';

import AntButton from '../../../../../components/AntButton/AntButton';
import MobileModalForm from '../../../../../components/Form/MobileModalForm';
import * as localizationKeys from '../../../../../consts/localization/localizationKeys';
import useIsMobileViewport from '../../../../../hooks/useIsMobileViewport';
import {getLocalizedStrings} from '../../../../../services/localization/localizationService';
import log from '../../../../../services/logger/log';
import uploadFileModalService from './uploadFileModalService';

const {Dragger} = Upload;

const UploadFileModal = (props) => {
    const localizedStrings = getLocalizedStrings();
    const isMobile = useIsMobileViewport();
    const [form] = Form.useForm();

    const [file, setFile] = useState(null);

    const {onOk, onCancel} = props;

    const modalData = uploadFileModalService.getUploadFileModalContent();

    const {title, submitButton, cancelButton} = modalData;

    const onUpload = async () => {
        try {
            await onOk(file);
        } catch (error) {
            log.error(`UploadFile - validate failed: ${error}`);
        }
    };

    const onChange = async (info) => {
        const fileObj = info.fileList[0]?.originFileObj;

        setFile(fileObj);
    };

    const fileUpload = (
        <Dragger
            maxCount={1}
            name='file'
            multiple={false}
            accept='.csv,text/csv'
            onChange={onChange}
            customRequest={({onSuccess}) => onSuccess('ok')}
        >
            <p className='ant-upload-drag-icon'>
                <InboxOutlined />
            </p>
            <p className='ant-upload-text'>
                {localizedStrings[localizationKeys.BUILDING_PROFILE_PAGE_UPLOAD_FILE_SUBTITLE]}
            </p>
            <p className='ant-upload-hint'>
                {localizedStrings[localizationKeys.BUILDING_PROFILE_PAGE_UPLOAD_FILE_DESCRIPTION]}
            </p>
        </Dragger>
    );

    if (isMobile) {
        return (
            <MobileModalForm
                form={form}
                formName='building-file-import-mobile'
                className='building-file-import-mobile'
                title={title}
                closeLabel={localizedStrings[localizationKeys.DC_PAGE_MOBILE_CLOSE_FORM]}
                onFinish={onUpload}
                onCancel={onCancel}
                submitButton={submitButton}
                cancelButton={cancelButton}
                submitDisabled={!file}
            >
                {fileUpload}
            </MobileModalForm>
        );
    }

    return (
        <div className='upload-file-modal-layout'>
            <div className='upload-file-modal-content px-[110px] pt-[42px]'>
                {title && <h3 className='font-semibold text-24 text-charcoal text-center pb-11'>{title}</h3>}
                {fileUpload}
            </div>

            <Divider className='mt-[30px] mb-[26px]' />
            <div className='upload-file-modal-actions flex justify-between items-center px-[55px]'>
                {cancelButton && (
                    <AntButton className='h-[50px]' type='button' onClick={onCancel} bordered cancelHover>
                        {cancelButton}
                    </AntButton>
                )}
                <AntButton className='h-[50px]' type='button' onClick={onUpload} primary disabled={!file}>
                    {submitButton}
                </AntButton>
            </div>
        </div>
    );
};

export default UploadFileModal;
